module.exports = "/_next/static/images/f52dbca6e75d171799692adc86008618-gray-mark.svg.webp";